<template>
  <div class="container">
    <div v-if="list.length>0">
    <div  class="my_concent" v-for="(item,index) in list" :key="index">
      <div class="list_div">
        <div class="name_div">领取人</div>
        <div>{{item.drawname}}</div>
      </div>
      <div class="list_div">
        <div class="name_div">领取时间</div>
        <div>{{item.drawtime}}</div>
      </div>
      <div class="list_div">
        <div class="name_div">使用状态</div>
        <div v-if="item.ischeckorder==1" style="color:#32C25A;">已下单</div>
        <div v-else>未下单</div>
      </div>
      <div class="list_div" v-if="item.ischeckorder==1">
        <div class="name_div">订单号</div>
        <div>{{item.orderid}}</div>
      </div>
    </div>
     </div>
    <div v-else class="no_data">
      <img src="../../assets/images/noOrder_Icon.png">
      <div>暂无领取记录</div>
    </div>
  </div>
</template>

<script>
import { customRequestAjax } from "@/axiosApi";
export default {
  name: "getDetails",
  data() {
    return {
      list: [
        // {
        //   drawname: "清风名学生",
        //   drawtime: "2022-07-21 16:12:09",
        //   ischeckorder: "1",
        //   orderid: "chueg84937535"
        // },
        // {
        //   drawname: "清风名学生",
        //   drawtime: "2022-07-21 16:12:09",
        //   ischeckorder: "0",
        //   orderid: ""
        // },
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    getData: function() {
      var that = this;
      var urlAddress = "Wxmall/Prizes/getPrizesShareDetail?prizeid=" + that.$route.query.prizeid;
      customRequestAjax(urlAddress).then(res => {
        if (res.data.code === 200) {
          that.list = res.data.list;
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 0.6rem;
  .my_concent {
    margin: 0.11rem;
    background: #fff;
    border-radius: 0.08rem;
    padding: 0.15rem 0.12rem 0.05rem 0.12rem;
    position: relative;
    font-size: 0.14rem;
    color: #333333;
    .list_div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      padding-bottom: 0.1rem;
      .name_div {
        width: 0.85rem;
        color: #666666;
        font-size: 0.14rem;
      }
    }
  }
  .noprize {
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .no_data {
    font-size: 0.14rem;
    text-align: center;
    margin-top: 2rem;
    img {
      width: 0.9rem;
      display: inline-block;
    }
  }
}
</style>
<style lang="scss">
.container .additional .field .van-cell__title {
  width: 0.72rem;
}
.container .additional .van-cell__title span {
  font-size: 0.12rem;
}
.container .additional .van-cell__value .van-field__control {
  font-size: 0.12rem;
  line-height: 0.25rem;
}
.container .additional .van-cell__value .van-field__control::placeholder {
  font-size: 0.12rem;
  line-height: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/prize/getDetails.vue